import { useBaseUrl } from '@/shared/lib/url';

export function getBaseUrl() {
  return useBaseUrl();
}

export async function downloadFile(url: string, filename: string) {
  const response = await fetch(getBaseUrl() + url);
  const blob = await response.blob();
  const file = new File([blob], filename, { type: blob.type });

  return file;
}
